import React from 'react'
import { message, notification, Modal, Button, Tag } from 'antd'
import { DropdownItem } from "reactstrap"
import { bulkMergeBatches } from "../../../../../services/api/3dApi"
import ActionChangeStatus from "./ActionChangeStatus"
import ActionChangeSewing from './ActionChangeSewing'
import classNames from 'classnames'
import { getLocalData } from "../../../../../services/StorageServices"
import { parseJwt } from "../../../../../helpers/parseToken"
import { ActionForceRetry } from './ActionForceRetry'
import ActionChangePrintPartner from './ActionChangePrintPartner'

const ActionSend = (props) => {
    const {
        selectedItems, handleSendLoading, refreshBatches, isOpen,
        showModal, closeModal, toggleSelectAll, batches, filters, isForceModal, onChangeForceModal,
        showModalUpdateSewing, onshowModalUpdateSewing, onCloseModalUpdateSewing, open, onShowModal2, onHideModal,
        showModalChangePrintPartner, onShowModalChangePrintPartner, onCloseModalChangePrintPartner
    } = props
    const listBatchSelected = batches.filter(batch => selectedItems.includes(batch._id)) || []

    const role = parseJwt(getLocalData('accessToken')).roles || []
    const isAdmin = role.some(item => item.name === "fac_admin")


    const _actionSendBulk = async () => {
        handleSendLoading(true)
        try {
            const newListBatchSelected = listBatchSelected.map(i => {
                const { tags = [], _id } = Object.assign({}, i)
                return !tags.includes("force_rgb") && _id
            }).filter(Boolean)

            const payload = {
                list_batch_id: newListBatchSelected,
                // location,
                need_convert_cmyk: false,
            }

            const { data: response } = await bulkMergeBatches(payload)
            const { success, data, error } = response

            if (!success) {
                message.error(error)
                props.toggleSelectAll(false)
                return handleSendLoading(false)
            }

            const { successJobs = [], failed = [] } = data

            notification.open({
                message: 'Xử lý file sản xuất',
                description: <div>Có <strong className="text-success">{successJobs.length}</strong> lô bắt đầu quá trình xử
                    lý file, <strong className="text-danger">{failed.length}</strong> lô đã chuyển trạng thái sản xuất.
                </div>,
                onClick: () => {
                    console.log('Notification Clicked!')
                },
                duration: 5
            })

            handleSendLoading(false)
            refreshBatches()
            props.toggleSelectAll(false)
            onHideModal()
        } catch (e) {
            message.error(e.message)
            return handleSendLoading(false)
        }
    }

    const handleOk = () => {
        _actionSendBulk()
    }

    return (
        <div>
            {
                isAdmin &&
                <DropdownItem onClick={() => onChangeForceModal(true)}>Force retry</DropdownItem>
            }
            <DropdownItem onClick={onShowModal2}>Xử lý file sản xuất</DropdownItem>
            <DropdownItem onClick={showModal}>Chuyển lô chờ may</DropdownItem>
            <DropdownItem onClick={onShowModalChangePrintPartner}>Đổi đối tác in/ép</DropdownItem>
            {filters.status === 'wait_to_sew' && (filters.partner === 'SWAT' || filters.partner === 'BU CHI TIET') &&
                <DropdownItem onClick={onshowModalUpdateSewing}>Chuyển lô Đang may</DropdownItem>
            }
            <ActionChangeStatus
                isOpen={isOpen}
                closeModal={closeModal}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            <ActionChangeSewing
                isOpen={showModalUpdateSewing}
                closeModal={onCloseModalUpdateSewing}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            <ActionForceRetry
                isOpen={isForceModal}
                closeModal={() => onChangeForceModal(false)}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            <ActionChangePrintPartner
                isOpen={showModalChangePrintPartner}
                closeModal={onCloseModalChangePrintPartner}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            <Modal
                title="Xử lý file sản xuất"
                visible={open}
                onOk={handleOk}
                onCancel={onHideModal}
                className="custom-modal-confirm-batch"
                footer={[
                    <Button onClick={onHideModal}>Trở về</Button>,
                    <Button type="primary" onClick={handleOk}>Xử lý</Button>
                ]}
            >
                {/* <label className="font-weight-bold d-block">Chọn địa điểm</label>
                <Select
                    placeholder={'Chọn địa điểm sản xuất'}
                    value={location}
                    onChange={handleChangeLocation}
                >
                    {
                        LOCATION.map((item, i) => (
                            <Select.Option key={i} value={item.value}>{item.label}</Select.Option>
                        ))
                    }
                </Select> */}
                <div className='mt-0'>
                    <h6>Xác nhận download / gộp file in của {listBatchSelected.filter(i => !i.tags.includes("force_rgb")).length} lô:</h6>
                    <ul>
                        {listBatchSelected.map((batch) => {
                            const { status, tags = [] } = Object.assign({}, batch)
                            const isForceRGB = tags.includes("force_rgb")

                            const color = classNames({
                                'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
                                'printing progress-bar-animated progress-bar-striped': status === 'printing',
                                'printed': status === 'printed',
                                'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
                                'transferred': status === 'transferred',
                                'confirmed': status === 'confirmed',
                                'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
                                'sewing': status === 'sewing',
                                'completed': status === 'completed' || status === 'done',
                            })
                            return (
                                <li key={batch._id} style={{ textDecoration: isForceRGB ? "line-through" : 'none' }}>
                                    {`${batch.basename}`}
                                    <span className={`badge ${color} badge-pill mx-1`}>{status}</span>
                                    {isForceRGB && <Tag className='mr-0 mt-1' color="#dc3644">RGB</Tag>}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </Modal>
        </div>
    )
}

export default ActionSend
